export const SUPPORTED_LOCALES = [
  'en',
  'ko',
  'th',
  'zh-Hant',
  'ja',
  'hi',
  'tl',
  'ar',
] as const;

export type Locale = (typeof SUPPORTED_LOCALES)[number];

export const DEFAULT_LOCALE: Locale = 'en';

export const LOCALE_LABELS: Record<Locale, string> = {
  en: 'English',
  ko: '한국어',
  th: 'ไทย',
  'zh-Hant': '繁體中文',
  ja: '日本語',
  hi: 'हिन्दी',
  tl: 'Filipino',
  ar: 'العربية',
};

export const isValidLocale = (locale: string): locale is Locale => {
  return SUPPORTED_LOCALES.includes(locale as Locale);
};

